import $ from 'jquery'

function menuSetup () {
  // Scroll Menu
  function menuToggle () {
    var windowWidth = $(window).width()
    if (windowWidth > 767) {
      $(window).on('scroll', function () {
        if ($(window).scrollTop() > 405) {
          $('.main-nav').addClass('fixed-menu animated slideInDown')
        } else {
          $('.main-nav').removeClass('fixed-menu animated slideInDown')
        }
      })
    } else {
      $('.main-nav').addClass('fixed-menu animated slideInDown')
    }
  }
  menuToggle()

  // Carousel Auto Slide Off
  $('#event-carousel, #sponsor-carousel').carousel({
    interval: false
  })

  $(window).resize(function () {
    menuToggle()
  })

  $(document).on('click', '.bonn-nav a', function (e) {
    $(this).closest('.navbar-collapse.collapse.show').removeClass('show')
  })
}

export {
  menuSetup
}



// WEBPACK FOOTER //
// ./src/utils/menu.js